import React from 'react';
import { PropTypes } from 'prop-types';
import { Pie } from 'react-chartjs-2';

const PPAPIE = (props) => {
    const { annualResults, selectedFinancing, doughnutSlider } = props;

    const doughYears = doughnutSlider;

    const annualUtilityPayment =
        annualResults[doughYears].formattedAnnualBill -
            annualResults[doughYears].annualSolarSavings >
        0
            ? annualResults[doughYears].formattedAnnualBill -
              annualResults[doughYears].annualSolarSavings
            : 0;

    const ppaBillVsUtilityCostPie = {
        datasets: [
            {
                data: [
                    annualUtilityPayment.toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'),
                    annualResults[doughYears].formattedAnnualPPASavings,
                    annualResults[doughYears].formattedPPABill,
                ],
                backgroundColor: ['#ff61e2', '#61ff9a', '#1857B5'],
            },
        ],
        labels: ['Remaining Utility ($)', 'Savings ($)', 'PPA ($) '],
    };

    return (
        <div>
            {selectedFinancing === 1 ? (
                <Pie
                    height={323}
                    data={ppaBillVsUtilityCostPie}
                    options={{ maintainAspectRatio: true }}
                />
            ) : null}
        </div>
    );
};
PPAPIE.propTypes = {
    annualResults: PropTypes.object.isRequired,
    selectedFinancing: PropTypes.number.isRequired,
    doughnutSlider: PropTypes.number.isRequired,
};

export default PPAPIE;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/Graphs/PPAPIE/PPAPIE.js